/*
 * @Author: Teemo Ding
 * @Date: 2021-09-01 10:33:53
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-07 17:34:51
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/discount.ts
 */
import { getI18nFromGeneral } from 'src/tools/tools';
import { EnumStatus } from 'src/types/common/common';
export { EnumStatus };
export enum DiscountType {
  PercentageOff = 'PercentageOff',
  FixedReductionAmount = 'FixedReductionAmount',
}

export enum EShipping {
  Free = 'Free',
  Fixed = 'Fixed',
}

export enum EDiscount {
  DirectDiscount = 'DirectDiscount',
  FlashSale = 'FlashSale',
  GiftPurchase = 'GiftPurchase',
  SubscriptionBuy = 'SubscriptionBuy',
  Voucher = 'Voucher',
}

export enum EDiscountType {
  Percentage = 'Percentage',
  Reduction = 'Reduction',
  Gift = 'Gift',
  Shipping = 'Shipping',
}

export enum StatusChange {
  Publish = 'Publish',
  Archive = 'Archive',
  Restore = 'Restore',
  ToDraft = 'ToDraft',
  Duplicate = 'Duplicate',
}

export enum ModalType {
  ArchiveDiscount = 'ArchiveDiscount',
  UnableToPublish = 'UnableToPublish',
}

export enum ESubscriptionBuyType {
  PayUpfront = 'PayUpfront',
  RecurringPayment = 'RecurringPayment',
}
export const SubscriptionBuyType = {
  [ESubscriptionBuyType.PayUpfront]: getI18nFromGeneral(
    'general.subscriptionBuy.payUpfront',
  ),
  [ESubscriptionBuyType.RecurringPayment]: getI18nFromGeneral(
    'general.subscriptionBuy.recurringPayment',
  ),
};
